import Messages from '../../../store/messages';

angular
    .module('festzelt-os.modules.messages')
    .factory('Messages', [
        '$injector',
        'Message',
        ($injector, Message) => new Messages(Message, {
            injector: $injector
        })
    ]);



// WEBPACK FOOTER //
// ./src/app/modules/messages/store/messages.js